export default __webpack_public_path__ + "static/media/gis.d1d59d10.png";